// extracted by mini-css-extract-plugin
export default {"head__container":"styles_head__container__UsezD","head__title":"styles_head__title__-uNaj"};